import React from "react"
import RecommendItemsCard from "./recommenditemscard"
import * as styles from "../../styles/nextroutesection.module.scss" // スタイルを流用
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTools } from "@fortawesome/free-solid-svg-icons" // アイテムっぽいアイコンに変更

const RecommendItems = () => {
  // ★ ここに表示したいアイテム記事の slug とラベルを 4〜5個 並べてください
  const items = [
    { slug: "others-gsevenxmarkiii", label: "愛用カメラ" },
    { slug: "others-gopro13", label: "GoPro13" },
    { slug: "others-mirrorshield", label: "ヘルメットシールド" },
    { slug: "others-sidebag", label: "サイドバッグ" },
  ]

  return (
    <div className={styles.sectionWrapper}>
      <h2 className={styles.label}>
        <FontAwesomeIcon icon={faTools} className={styles.mapIcon} />
        愛用アイテム・装備
      </h2>

      {items.map((item, index) => (
        <RecommendItemsCard
          key={item.slug}
          slug={item.slug}
          label={item.label}
          isSlim={index > 0} // 0番目（1枚目）は大きく、それ以降はスリムに
        />
      ))}
    </div>
  )
}

export default RecommendItems
